// import { pipe } from "fp";

import * as Data from "~/Data";
import * as Log from "~/Log";
import { Mutable } from "~/Mutable";
import { State as GlobalState } from "~/State";

/**
 * `Active` represents the `Identity` of the `Log` which is currently being
 * viewed.
 * */
export type Active = Log.Identity | undefined;

export type When<A> = {
  /** No log is currently being viewed; `Active` hasn't been set. */
  readonly inactive: () => A;

  /**
   * The `Active` log has been set, but only the `Identity` is known, not the
   * full `Log` which might be loading or errored-out */
  readonly unavailable?: (active: Log.Identity) => A;

  /** `Active` resolves to a full `Log` and is ready to use */
  readonly available: (active: Mutable<Log.Log>) => A;
  // TODO: Remove `Mutable`
};

export const equals = (a: Active) => (b: Active): boolean => {
  if (a === undefined && b === undefined) return true;
  if (a === undefined || b === undefined) return false;
  return Log.equals(a)(b);
};

export namespace State {
  export type State = Active;

  export const initial = (): State => undefined;

  export const when = <A>(
    { logs: { active, store } }: Mutable<GlobalState>,
    { inactive, unavailable = inactive, available }: When<A>
  ): A =>
    !active
      ? inactive()
      : pipe(
          store,
          Data.Store.Get.fromReference({
            id: Log.id(active),
            missing: () => unavailable(active),
            found: (log) => available(log),
          })
        );
}
